import { closeSession, updateAuthState } from 'gucciAuth';
import { safeGTMuaEventsPusher } from './gtm-utilities.es6';

const handleError = () => {
    console.error('Automatic CA logout process failed');
    safeGTMuaEventsPusher('nonInteractionEvent', 'order confirmation', 'silentCALogoutError');
};

const closeCASessionIfNeeded = ssaData => {
    if (ssaData.silentLogout && ssaData.logoutUrl) {
        safeGTMuaEventsPusher('nonInteractionEvent', 'order confirmation', 'silentCALogout', 'triggered', ssaData);
    } else {
        handleError();
    }
};

const silentCALogout = () => {
    const ssaData = JSON.parse(localStorage.getItem('asm_data'));

    if (ssaData) {
        closeCASessionIfNeeded(ssaData);
        const callback = () => console.log('Okta customer session is ended');
        closeSession(callback);
        updateAuthState();
    }
};

export { silentCALogout };
